/**
 * v-sf-trim 指令
 * @author：zhutao(01400150)
 * @date:2021-03-03
 * @desc 在el-input标签失焦时，将元素的值的首位空格去掉，v-model的trim修饰符不能与该指令一起使用
 * @example
 * ```vue
 * <el-input v-sf-trim></el-input>
 * ```
 */
let clickInEvent
const nodeEventRecorder = new Map()

document.addEventListener('mousedown', e => (clickInEvent = e))
document.addEventListener('mouseup', e => {
  nodeEventRecorder.forEach(value => {
    value(e, clickInEvent)
  })
})

function createHandler(el, binding, vnode) {
  return function(mouseup = {}, mousedown = {}) {
    if (
      !vnode ||
      !vnode.context ||
      !mouseup.target ||
      el.contains(mouseup.target) ||
      el.contains(mousedown.target) ||
      el === mouseup.target ||
      (vnode.context.popperElm &&
        (vnode.context.popperElm.contains(mouseup.target) ||
          vnode.context.popperElm.contains(mousedown.target)))
    ) {
      return
    }
    // 兼容element中的el-input type为textarea类型
    const inputDom = el.querySelector('input') || el.querySelector('textarea')
    if (!inputDom || !inputDom.value) {
      return false
    }
    inputDom.value = inputDom.value.trim()
    inputDom.dispatchEvent(
      new Event(binding.modifiers.lazy ? 'change' : 'input'),
    )
    // console.log('更新后')
    // console.log(inputDom.value + 'a')
  }
}

export default {
  bind(el, binding, vnode) {
    nodeEventRecorder.set(el, createHandler(el, binding, vnode))
  },
  update(el, binding, vnode) {
    nodeEventRecorder.set(el, createHandler(el, binding, vnode))
  },
  unbind(el) {
    nodeEventRecorder.delete(el)
  },
}
